import type { ForecastOverrideStatus } from '@/components/StoreMonitoring/ForecastManagement/types'
import type { RunStatus } from '@/hooks/useRouteOptimization'
import type { components } from '@/types/api/v1'

export type LockedOrderItem = {
  run_id: string
  order_id: string
  state: string
}

export type WebsocketStore = {
  runStatus: RunStatus[]
  lockedOrders: LockedOrderItem[]
  lockedSchedules: Gravitate.Schedule[]
  userTasks: components['schemas']['UserTaskResponse'][]
  forecastOverrideStatus: ForecastOverrideStatus
}

let store: WebsocketStore = {
  runStatus: [],
  lockedOrders: [],
  lockedSchedules: [],
  userTasks: [],
  forecastOverrideStatus: undefined,
}

// Listeners for subscriptions
const listeners = new Set<() => void>()

function emitChange() {
  for (const listener of listeners) listener()
}

// Public setter methods
export const websocketStore = {
  getSnapshot: () => store,

  subscribe(callback: () => void) {
    listeners.add(callback)
    return () => listeners.delete(callback)
  },

  update(updates: Partial<typeof store>) {
    store = { ...store, ...updates }
    emitChange()
  },
}
